import isNil from 'lodash/isNil';

import { goalReached, YMGoals } from '@/infrastructure/ym';
import { createReducerTypeSafe } from '@/utils/redux';

import {
  RemoveNotificationActionPayload,
  StoreAddNotificationActionPayload,
  storeAppType,
  StoreAppTypeActionPayload,
  storeFrameMode,
  StoreFrameModeActionPayload,
  StoreInitActionPayload,
  storeInitializationState,
  storeLoading,
  StoreLoadingActionPayload,
  storeLocale,
  StoreLocaleActionPayload,
  storeLogout,
  storeRemoveNotification,
  storeSaveNotification,
  storeToggle,
  StoreTogglePayload,
  storeViewMode,
  StoreViewModeActionPayload,
} from './actions';
import { initialState, State } from './types';

export const reducers = createReducerTypeSafe<State>(initialState, [
  [
    storeInitializationState,
    (state: State, { partner }: StoreInitActionPayload): State => ({ ...state, partner, initialized: true }),
  ],
  [
    storeLoading,
    (state: State, { loading, messageId }: StoreLoadingActionPayload): State => ({
      ...state,
      viewState: { ...state.viewState, loading, messageId },
    }),
  ],
  [
    storeLocale,
    (state: State, { locale }: StoreLocaleActionPayload): State => ({
      ...state,
      locale,
    }),
  ],
  [
    storeViewMode,
    (state: State, { isMobile, vh }: StoreViewModeActionPayload): State => {
      if (!isNil(isMobile) && (!state.initialized || isMobile !== state.viewState.isMobile)) {
        goalReached(isMobile ? YMGoals.IS_MOBILE : YMGoals.NO_MOBILE);
      }
      return (!isNil(isMobile) && isMobile !== state.viewState.isMobile) || (!isNil(vh) && vh !== state.viewState.vh)
        ? {
            ...state,
            viewState: {
              ...state.viewState,
              isMobile: !isNil(isMobile) ? isMobile : state.viewState.isMobile,
              vh: !isNil(vh) ? vh : state.viewState.vh,
            },
          }
        : state;
    },
  ],
  [
    storeFrameMode,
    (state: State, { isFrame }: StoreFrameModeActionPayload): State =>
      isFrame !== state.viewState.isFrame
        ? {
            ...state,
            viewState: {
              ...state.viewState,
              isFrame,
            },
          }
        : state,
  ],
  [
    storeAppType,
    (state: State, { type }: StoreAppTypeActionPayload): State => ({
      ...state,
      application: type,
    }),
  ],
  [
    storeSaveNotification,
    (state: State, notification: StoreAddNotificationActionPayload): State => ({
      ...state,
      notifications: [notification, ...state.notifications],
    }),
  ],
  [
    storeRemoveNotification,
    (state: State, { id, type }: RemoveNotificationActionPayload): State => ({
      ...state,
      notifications: [
        ...state.notifications.filter((saved) => !(id && saved.id === id) && !(type && saved.type === type)),
      ],
    }),
  ],
  [storeToggle, (state: State, toggle: StoreTogglePayload): State => ({ ...state, toggle })],
  [
    storeLogout,
    (state: State): State => ({
      initialized: true,
      viewState: {
        loading: state.viewState.loading,
        isMobile: state.viewState.isMobile,
        isFrame: state.viewState.isFrame,
      },
      notifications: [],
      locale: state.locale,
      application: state.application,
    }),
  ],
]);

export default reducers;
